/**
 * Base64 encodes the given string, then makes it url-safe.
 *
 * @param str The string.
 * @returns {string} The base64-encoded, url-safe string.
 */
export function base64EncodeUrlSafe(str) {
  const base64 = btoa(str);
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}


// WEBPACK FOOTER //
// ./src/Helpers/base64.js